import { formatDateDisplay } from 'utils/datetime';

/**
 * @typedef {Object} PermanentHomeBase
 * @property {{ name?: string }} [city]
 * @property {string} [effectiveTimestamp]
 *
 * @param {PermanentHomeBase | null | undefined} permanentHomeBase
 * @returns {string}
 */
export const formatEffectiveDate = (permanentHomeBase) => {
	if (permanentHomeBase == null) return '';
	return formatDateDisplay(permanentHomeBase.effectiveTimestamp);
};

/**
 * @param {PermanentHomeBase | null | undefined} permanentHomeBase
 * @returns {string}
 */
export const homeLocationName = (permanentHomeBase) => {
	if (permanentHomeBase == null) return '';
	return permanentHomeBase.city?.name ?? '';
};
